import { render, staticRenderFns } from "./GradingTableSelector.vue?vue&type=template&id=fefbaa1e&"
import script from "./GradingTableSelector.vue?vue&type=script&lang=js&"
export * from "./GradingTableSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports